<template>
    <button id="TV_INPUT" name="TV_INPUT" class="btn" data-vcode="Source" disabled :aria-label="`${$t('tvInput')}`">
        <img src="/images/icons/tvInput.svg" alt="" />
        <label aria-hidden="true">{{ $t('tvInput') }}</label>
    </button>
</template>
<script>
export default {};
</script>
